import React, { Component } from 'react';
import autobind from 'class-autobind';
import PropTypes from 'prop-types';

import { zfImagePropType } from 'zoomforth_codesbane_viewer/lib/prop_types.js';
import loadFittedImage from 'zoomforth_zfutils/load_fitted_image.js';
import { didComponentValueUpdate } from 'zoomforth_zfutils/react_helpers.js';

class FittedImage extends Component {
  constructor(props){
    super(props);

    this.fittedImageContainerNodeRef = null;

    autobind(this);
  }

  loadImage() {
    if (this.fittedImageContainerNodeRef) {
      if(this.props.zfImage){
        const fittedImage = {
          container: this.fittedImageContainerNodeRef,
          imageSrc: this.props.zfImage.src,
          altText: this.props.altText,
          enableBackgroundCover: true,
        };
        if(this.props.zfImage.cropData){
          fittedImage['imageCss'] = { 'border-radius': `${this.props.zfImage.cropData.borderRadius}%` };
        }
        loadFittedImage(fittedImage);
      }else{ // handle legacy images
        if(this.props.style){
          fittedImage['imageCss'] = this.props.style;
        }

        loadFittedImage({
          container: this.fittedImageContainerNodeRef,
          imageSrc: this.props.src,
          altText: this.props.altText,
          enableBackgroundCover: true
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    // If the image is changed in the editor we want to reload the image
    if (
        didComponentValueUpdate(
          this.props.zfImage && this.props.zfImage.src,
          prevProps.zfImage && prevProps.zfImage.src
        )
        || didComponentValueUpdate(prevProps.src, this.props.src)
      ){
      this.loadImage();
    }
  }

  componentDidMount() {
    this.loadImage();
  }

  handleFittedImageContainerNodeRef(ref) {
    this.fittedImageContainerNodeRef = ref;
  }

  render(){
    return (
      <div ref={this.handleFittedImageContainerNodeRef} className={this.props.className} />
    );
  }
}

FittedImage.propTypes = {
  zfImage: zfImagePropType,
  src: PropTypes.string,
  altText: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};

export default FittedImage;
